import { forwardRef } from 'react';
import { FormControlLabel, Switch, SwitchProps } from '@mui/material';
import styles from './index.module.scss';
import classNames from 'classnames';

export default forwardRef((props: SwitchProps, ref) => {
  const { onChange, name, ...switchProps } = props;

  return !props.title ? (
    <Switch
      inputRef={ref}
      onChange={onChange}
      classes={{
        root: classNames('h-full', styles.root),
        switchBase: styles.switchBase,
        thumb: styles.thumb,
        track: styles.track,
        checked: styles.checked,
        disabled: styles.disabled,
      }}
      {...switchProps}
      data-cy={name ?? ''}
    />
  ) : (
    <FormControlLabel
      className={styles.label}
      control={
        <Switch
          onChange={onChange}
          classes={{
            root: classNames('h-full', styles.root),
            switchBase: styles.switchBase,
            thumb: styles.thumb,
            track: styles.track,
            checked: styles.checked,
            disabled: styles.disabled,
          }}
          {...switchProps}
          data-cy={name ?? ''}
        />
      }
      label={props.title}
    />
  );
});
